module.exports = __webpack_public_path__ + "img/Menu-03.c1c53517.webp";